module.exports = __webpack_public_path__ + "images/emoji/neckbeard.518e18ca0e08f31f8052.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/neckbeard.png
// module id = +IBV
// module chunks = 13